import request from '@/utils/request'

export function getWxConfig (params) {
  return request({
    url: '/common/wx/js/config/',
    method: 'get',
    params
  })
}
